<template>
	<div class="index-box">
		
		<div class="block" :style="{height:fullHeight+'px'}">
			<block1 :isIphoneX="isIphoneX"></block1>
		</div>
		
	</div>
</template>

<script>
	import Block1 from '@/mobilComponents/mobileblock1'
	import store from '@/store/store'
	export default {
		name:'MobilIndex',
		data() {
			return {
				fullHeight:document.documentElement.clientHeight,
				// imgArr1:[require('../assets/banner1-1.png'),require('../assets/banner1-2.png'),require('../assets/banner1-3.png')],
				// imgArr2:[require('../assets/banner2-1.png'),require('../assets/banner2-2.png'),require('../assets/banner2-3.png')],
				// imgArr3:[require('../assets/banner3-1.png'),require('../assets/banner3-2.png'),require('../assets/banner3-3.png')],
        news:'show'
			}
		},
		components:{
			Block1
		},
		mounted(){
			const that = this
			window.onresize = () =>{
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.fullHeight = window.fullHeight;

				})()
			},
			window.addEventListener('scroll',this.getScrollHeight);
		},
		computed:{
			isIphoneX(){
				return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
			}
		},
		watch:{
			fullHeight (val){
				if(!this.timer){
					this.fullHeight = val
					this.timer = true
					let that = this
					setTimeout(function () {
						that.timer = false
					},400)
				}
			}
		},
		created:function () {
			//this.$store.commit('isIndex');
			this.$store.commit('inWhichPage',{page:'index'});
		},
		methods:{
			getScrollHeight:function () {
				var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			},
      clickDialogClose:function () {
        this.news = '';
      }
		},
		destoryed:function () {
		}
	}
</script>
<style>
.index-box{
	background: url("../assets/phone_bg.png") no-repeat fixed top;
	background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/mobilPage/index.vue